module.exports = __webpack_public_path__ + "img/twitter.c84e97c9.svg";